import React, { useEffect } from "react";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const SchoolTransport = () => {
  useEffect(() => {
    document.title = "School Transport -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Facilities</li>
          <li>School Transport</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> School Transport </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="clearfix">
                <LazyLoad>
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/Images/Transport.jpg"
                    alt="TAFS"
                    className="col-lg-3 col-md-4 float-md-end  left-img img-fluid"
                  />{" "}
                </LazyLoad>
                <p>
                  There are two school owned buses. Additionally, the school
                  hires buses to help students commute. The routes of the school
                  buses are drawn and the parents should consult the school
                  transport in-charge for necessary details. Bus facility is not
                  mandatory.
                </p>

                <div className="schooltrans">
                  <Link to="/TransportRules"> Transport Rules </Link>
                  <Link to="/BusRoutes"> Bus Routes </Link>
                  <Link to="/BusRules"> Bus Rules </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/SchoolCabs.pdf"
                    target="_blank"
                  >
                    {" "}
                    Minimum Standards of School Safety for Private School Cabs
                    organised by Parents{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Guideline for Safety.pdf"
                    target="_blank"
                  >
                    {" "}
                    Guideline for Safety of School Students{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Driving.jpg"
                    target="_blank"
                  >
                    {" "}
                    Prevention Of Overloading Of School Vans/buses And Underage
                    Students's Driving{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/School Bus Form.pdf"
                    target="_blank"
                  >
                    {" "}
                    School Bus Form{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Private Vehicles.pdf"
                    target="_blank"
                  >
                    {" "}
                    Use of Private Vehicles{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Parking of Vehicle.pdf"
                    target="_blank"
                  >
                    {" "}
                    Parking of Vehicle{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/School Transport.pdf"
                    target="_blank"
                  >
                    {" "}
                    School Transport{" "}
                  </Link>
                  <Link to="/SchoolTransportUKGtoXII">
                    {" "}
                    School Transport dated 12 Mar 2024{" "}
                  </Link>

                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/School Vansbuses.pdf"
                    target="_blank"
                  >
                    {" "}
                    Prevention Of Overloading Of School Vans/buses And Underage
                    Students Driving - 16 Apr 24{" "}
                  </Link>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/vehicle-circular.pdf"
                    target="_blank"
                  >
                    Circular for Parking of Vehicle dated 14 Jan 26
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolTransport;
